import { useState } from 'react';
import { tentarInstalar } from '@/lib/app';
import { mostrarToast } from '@/lib/formularioGuiado';
import FolhaInstalarDoisPassos from './FolhaInstalarDoisPassos';
import FolhaColocarNaTela from './FolhaColocarNaTela';
import FolhaAbrirNavegador from './FolhaAbrirNavegador';

type Folha = null | 'android' | 'ios' | 'ios-outro';

// ---------------------------------------------------------------------------
// Faixa fininha no topo das telas sensíveis (ficha, Pix, caixa, portaria):
// "Instalar app" + X. Fica no fluxo da página (nunca cobre campo nem botão).
// ---------------------------------------------------------------------------
export default function FaixaInstalar({ aoFechar }: { aoFechar: () => void }) {
  const [folha, setFolha] = useState<Folha>(null);

  function instalar() {
    const r = tentarInstalar();
    if (r === 'prompt') return;
    if (r === 'android') {
      setFolha('android');
      return;
    }
    if (r === 'ios') {
      setFolha('ios');
      return;
    }
    if (r === 'ios-outro') {
      setFolha('ios-outro');
      return;
    }
    mostrarToast('Use o menu do navegador para instalar o Se Liga.');
  }

  return (
    <>
      <div
        className="relative z-[92] flex items-center gap-2 bg-foreground-950 px-4 py-1.5"
        style={{ paddingTop: 'max(0.375rem, env(safe-area-inset-top))' }}
      >
        <span className="flex h-4 w-4 shrink-0 items-center justify-center text-white/80">
          <i className="ri-download-2-line text-sm" aria-hidden />
        </span>
        <p className="min-w-0 flex-1 truncate text-[12px] font-semibold text-white/90">
          Instalar app
        </p>
        <button
          type="button"
          onClick={instalar}
          className="shrink-0 cursor-pointer whitespace-nowrap rounded-full bg-accent-500 px-3 py-1 text-[12px] font-bold text-white"
        >
          Instalar
        </button>
        <button
          type="button"
          onClick={aoFechar}
          aria-label="Agora não"
          className="flex shrink-0 cursor-pointer items-center gap-1 whitespace-nowrap rounded-full px-1.5 py-1 text-[11px] font-semibold text-white/80 transition-colors hover:bg-white/10"
        >
          <i className="ri-close-line text-sm" aria-hidden />
          Agora não
        </button>
      </div>

      {folha === 'android' && <FolhaInstalarDoisPassos aoFechar={() => setFolha(null)} />}
      {folha === 'ios' && <FolhaColocarNaTela aoFechar={() => setFolha(null)} />}
      {folha === 'ios-outro' && (
        <FolhaAbrirNavegador alvo="ios" aoFechar={() => setFolha(null)} />
      )}
    </>
  );
}